import React from 'react';
import PropTypes from 'prop-types';
import { useObserver } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { useRouterStore, useClientStore, useAppManager } from 'apps/hooks';
import { ContextAppManager } from 'apps/context/appManager';
import { ContextManagerProvider } from 'apps/context/hooks';
import { useViewerControl } from 'libs/rendering/gltf/hooks';

import { FileViewerManager } from 'apps/viewer/appManager';
import { FileTabNew } from 'apps/repository/views/fileNew';

import { CadViewerWrapper } from 'libs/rendering/gltf/viewer.styled';
import { Header } from 'libs/rendering/components/header';
import { SystemMessageStyled } from 'libs/rendering/gltf/components/systemMessage/systemMessage.styled';

import { ErrorHandler } from 'libs/rendering/components/errorHandler';

const FileError = props => {
  // TODO: Should have an interface to try to recover from an error
  return (
    <>
      <Header file={props.file} />
      <SystemMessageStyled type='error'>
        <Trans>
          <strong>This CAD Room encountered an internal error.</strong> Sorry
          about that! Please, go back or try again.
        </Trans>
      </SystemMessageStyled>
    </>
  );
};

FileError.propTypes = {
  file: PropTypes.object,
};

export const FilePage = props => {
  // TODO: Should implement ErrorState and key here ala filters.js
  return (
    <ErrorHandler ErrorComponent={FileError} {...props}>
      <FilePageInner {...props} />
    </ErrorHandler>
  );
};

const FilePageInner = withNamespaces()(function _FilePage(props) {
  const clientStore = useClientStore();
  const routerStore = useRouterStore();
  const viewerControl = useViewerControl();

  const fileViewerManager = useAppManager(
    FileViewerManager,
    null,
    {
      profile: props.params.get('profile'),
      initiative: props.params.get('initiative'),
      slug: props.params.get('slug'),
      basepath: props.params.get('basepath'),
      contributionId: props.params.get('contributionId'),
    },
    true,
    [
      props.params.get('profile'),
      props.params.get('initiative'),
      props.params.get('slug'),
      props.params.get('basepath'),
      props.params.get('contributionId'),
    ],
  );

  const contextManager = useAppManager(
    ContextAppManager,
    null,
    {
      resourceId: () => routerStore.params.toJSON().basepath,
      clientStore,
      viewerControl,
      contextAppHolder: fileViewerManager,
    },
    true,
    [fileViewerManager],
  );

  return useObserver(() => {
    let returnRoute = clientStore.spaceRoute.route;
    const basepath = routerStore.params.get('basepath');
    const basepathSegs = basepath ? basepath.split('/') : [];
    const projectRouteParams = routerStore.params.toJSON();
    const returnParams = projectRouteParams;
    delete projectRouteParams.basepath;

    if (basepathSegs.length > 1) {
      returnRoute = `${clientStore.spaceRoute.route}.files.directory`;
      const returnBasepath = basepathSegs
        .slice(0, basepathSegs.length - 1)
        .join('/');
      if (returnBasepath) {
        returnParams.basepath = returnBasepath;
      } else {
        delete returnParams.basepath;
      }
    }

    const returnLink = { route: returnRoute, params: returnParams };

    // FIXME: Provider only needed until we refactor GLTFViewer (and other viewers) to use Hooks
    return (
      <CadViewerWrapper>
        <Header file={fileViewerManager.file} />
        <ContextManagerProvider value={contextManager}>
          <FileTabNew manager={fileViewerManager} returnLink={returnLink} />
        </ContextManagerProvider>
      </CadViewerWrapper>
    );
  });
});

FilePage.propTypes = {
  routerStore: PropTypes.object,
  clientStore: PropTypes.object,
  params: PropTypes.object,
};
